import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Constant } from 'src/app/shared/service/utils/contant';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-prevision',
  templateUrl: './prevision.component.html',
  styleUrl: './prevision.component.scss'
})
export class PrevisionComponent implements OnInit {

  exercice: number = new Date().getFullYear();

  chapitres: any[] = [];
  sousChapitres: any[] = [];
  previsions: any[] = [];
  paginatedProjets: any[] = [];
  first = 0;
  rows = 10;
  totalRecords = 0;
  isLoading = false;

  selectedChapitre: any = null;
  selectedSousChapitre: any = null;
  selectedCompte: any = null;
  previsionForm: any = {};

  @ViewChild('previsionModal') previsionModal: any;

  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService
  ) { }

  ngOnInit(): void {
    const stored = this.localStorage.getExerciceToUserToSuivieEvaluation();
    if (stored) {
      this.exercice = Number(stored) || new Date().getFullYear();
    }
    this.loadChapitres();
    this.loadData();
  }

  onExerciceChange(): void {
    this.selectedChapitre = null;
    this.selectedSousChapitre = null;
    this.loadChapitres();
    this.loadData();
  }

  loadChapitres(): void {
    this.paramService.getBordereauChapitres({ annee: this.exercice }).subscribe(
      (response: any) => {
        this.chapitres = response.data || [];
      },
      (error: any) => {
        this.chapitres = [];
      }
    );
  }

  loadSousChapitres(): void {
    this.selectedSousChapitre = null;
    this.paramService.getBordereauSousChapitres({
      annee: this.exercice,
      chapitre_id: this.selectedChapitre || ''
    }).subscribe(
      (response: any) => {
        this.sousChapitres = response.data || [];
      },
      (error: any) => {
        this.sousChapitres = [];
      }
    );
  }

  loadData(): void {
    this.isLoading = false;
    this.ngxService.start();
    this.paramService.getBordereauPrevisions({
      annee: this.exercice,
      sous_chapitre_id: this.selectedSousChapitre || ''
    }).subscribe(
      (response: any) => {
        this.previsions = response.data || [];
        this.totalRecords = this.previsions.length;
        this.updatePaginated();
        this.isLoading = true;
        this.ngxService.stop();
      },
      (error: any) => {
        this.isLoading = true;
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue lors du chargement des prévisions'
        });
      }
    );
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePaginated();
  }

  updatePaginated() {
    this.paginatedProjets = this.previsions.slice(this.first, this.first + this.rows);
  }

  openModal(compte: any) {
    this.selectedCompte = compte;
    this.previsionForm = {
      budget_primitif: compte.prevision?.budget_primitif || 0,
      total_previsionnel: compte.prevision?.total_previsionnel || 0,
      modification: compte.prevision?.modification || 0,
      annee: this.exercice,
    };
    this.modalService.open(this.previsionModal, { centered: true, backdrop: 'static', size: 'lg' });
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files?.[0];
    if (!file) {
      return;
    }
    const ext = file.name.toLowerCase().split('.').pop();
    if (ext !== 'xlsx' && ext !== 'xls' && ext !== 'csv') {
      this.messageService.add({
        severity: 'warn',
        summary: Constant.suiviTitle,
        detail: 'Veuillez choisir un fichier Excel ou CSV (.xlsx, .xls ou .csv)'
      });
      event.target.value = '';
      return;
    }
    this.ngxService.start();
    this.paramService.importBordereauPrevisions(file, this.exercice).subscribe(
      (response: any) => {
        this.ngxService.stop();
        event.target.value = '';
        this.messageService.add({
          severity: 'success',
          summary: Constant.suiviTitle,
          detail: response?.message || 'Import effectué avec succès'
        });
        this.loadData();
      },
      (error: any) => {
        this.ngxService.stop();
        event.target.value = '';
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue lors de l\'import'
        });
      }
    );
  }

  calculateModification() {
    this.previsionForm.modification =
      Number(this.previsionForm.total_previsionnel || 0) - Number(this.previsionForm.budget_primitif || 0);
  }

  save() {
    if (!this.selectedCompte) {
      return;
    }
    if (Number(this.previsionForm.budget_primitif) < 10000) {
      this.messageService.add({
        severity: 'warn',
        summary: Constant.suiviTitle,
        detail: 'Le budget primitif doit être au minimum de 10 000'
      });
      return;
    }
    if (Number(this.previsionForm.total_previsionnel) < 10000) {
      this.messageService.add({
        severity: 'warn',
        summary: Constant.suiviTitle,
        detail: 'Le budget total doit être au minimum de 10 000'
      });
      return;
    }
    this.calculateModification();
    this.ngxService.start();
    this.paramService.saveBordereauPrevision(this.selectedCompte.reference, this.previsionForm).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.modalService.dismissAll();
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.loadData();
      },
      (error: any) => {
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue'
        });
      }
    );
  }
}
